
function showMiniCart() {
  let miniCart = document.querySelector(".mini-cart");
  miniCart.classList.add("active");

  // document.removeEventListener("click", closeMiniCart);

  // setTimeout(() => {
  //   document.addEventListener("click", closeMiniCart);
  // }, 0);
}


function closeMiniCart(e) {
  let miniCart = document.querySelector(".mini-cart");

  miniCart.classList.remove("active");
  // if (!miniCart.contains(e.target)) {
  //   document.removeEventListener("click", closeMiniCart);
  //   document.addEventListener("click", closeMiniCart);
  // }
}
let closeMiniCartButton = document.querySelector(".mini-cart__close");

closeMiniCartButton.addEventListener("click", (e) => {
  let miniCart = document.querySelector(".mini-cart");
  miniCart.classList.remove("active");
});

//---- Add to cart ----------------------------------
if (openCartBtn) {
  const miniCart = document.querySelector(".mini-cart");
  openCartBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      showMiniCart();
    });
  });
}

function showConfirm(message) {
  const confirmBox = document.getElementById('customConfirm');
  const overlay = document.getElementById('overlay-fullscreen');
  const confirmMessage = document.getElementById('confirmMessage');
  confirmMessage.textContent = message;
  confirmBox.style.display = 'block';
  overlay.style.display = 'block';

  return new Promise((resolve) => {
    document.getElementById('confirmOk').onclick = () => {
      confirmBox.style.display = 'none';
      overlay.style.display = 'none';
      resolve(true);
    };

    document.getElementById('confirmCancel').onclick = () => {
      confirmBox.style.display = 'none';
      overlay.style.display = 'none';
      resolve(false);
    };
    
    document.getElementById('overlay-fullscreen').onclick = () => {
      confirmBox.style.display = 'none';
      overlay.style.display = 'none';
      resolve(false);
    };
  });
}

function showCartOverlay() {
  const overlay = document.querySelector(".overlay-cart");
  if(overlay) {
    overlay.classList.add('active');
  }
}
function hideCartOverlay() {
  const overlay = document.querySelector(".overlay-cart");
  if(overlay) {
    overlay.classList.remove('active');
  }
}
let up = document.querySelectorAll("[data-btn-plus]");
let down = document.querySelectorAll("[data-btn-minus]");
let deleteItem = document.querySelectorAll(".mini-cart__order-delete");

up.forEach((item) => {
  item.addEventListener("click", (e) => {
    let product = e.target.closest(".mini-cart__order");
    if (product) {
      let input = product.querySelector(".quantity-input");
      let key = product.getAttribute("data-key");
      let value = parseInt(input.value, 10);

      value = isNaN(value) ? 0 : value;
      value++;

      // input.value = value;
      changeItemTotalPrice(product, value);
      changeItemQuantity(key, value);
      changeCartQuantity("+");
    }
  });
});

down.forEach((item) => {
  item.addEventListener("click", (e) => {
    let product = e.target.closest(".mini-cart__order");
    if (product) {
      let input = product.querySelector(".quantity-input");
      let key = product.getAttribute("data-key");
      let value = parseInt(input.value, 10);

      if (value > 1) {
        value = isNaN(value) ? 1 : value;
        value--;
        // input.value = value;
        changeItemTotalPrice(product, value);
        changeItemQuantity(key, value);
        changeCartQuantity("-");
      } else {
        product.remove();
        changeItemQuantity(key, 0);
      }
    }
  });
});

function changeCartQuantity(sign) {
  document.querySelectorAll(".cartt").forEach((cart) => {
    let currentValue = parseInt(cart.textContent, 10) || 0;
    if (sign === "+") {
      currentValue++;
    } else if (sign === "-" && currentValue > 0) {
      currentValue--;
    }
    cart.textContent = currentValue;
  });
}

deleteItem.forEach((item) => {
  item.addEventListener("click", (e) => {
    let product = e.target.closest(".mini-cart__order");
    let key = product.getAttribute("data-key");
    changeItemQuantity(key, 0);
    product.remove();
  });
});

function changeItemTotalPrice(item, quantity, isNew) {
  // let strokeElement = item.querySelector(".item-total");
  // if (!strokeElement) {
  //   console.error("Total price element not found in:", item);
  //   return;
  // }
  // console.log(item.getAttribute("data-price"));
  // let pricePerItem = parseFloat(item.getAttribute("data-price")) * 100;
  // let totalPrice = pricePerItem * quantity;
  // if (isNew) {
  //   strokeElement.innerHTML = `${(totalPrice.toFixed(2) / 100).toFixed(2)} CAD`;
  // }
  // strokeElement.innerHTML = `${(totalPrice.toFixed(2) / 100).toFixed(2)}`;
}

function strokeToNumber(stroke) {
  return parseFloat(stroke.replace(/[^0-9.]/g, ""));
}

function changeItemQuantity(key, quantity) {
  showCartOverlay();
  console.log("Updating item:", key, "to quantity:", quantity);

  let updates = {};
  updates[key] = quantity;

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Cart updated:", data);
      getCartInformation(data);
      hideCartOverlay();
    })
    .catch((error) => {
      console.error("Error:", error);
      hideCartOverlay();
    });
}
// let cartButton = document.querySelector(".cartt-button");

// cartButton.addEventListener("click", (e) => {
//   e.preventDefault();
//   showMiniCart();
// });
function zFill(number, width) {
  const numberString = String(number);
  const paddingLength = Math.max(0, width - numberString.length);
  const paddedString = "0".repeat(paddingLength) + numberString;
  return paddedString;
}
function freeDeliveryAmount(items_subtotal_price) {
  let label = document.querySelector(".mini-cart__info .information-label");
  let amount = document.querySelector(".mini-cart__info .information-label b");
  let addMore = 7500 - parseInt(items_subtotal_price);
  if (addMore > 0) {
    addMore = zFill(addMore, 3);
    label.classList.remove("not-active");
    amount.textContent =
      "$" + addMore.slice(0, addMore.length - 2) + "." + addMore.slice(-2);
  } else {
    label.classList.add("not-active");
  }
}
async function getCartInformation(data) {
  if (!data) {
    data = await fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  console.log("Cart data:", data);
  let original_total_price = String(data.original_total_price);
  let items_subtotal_price = String(data.items_subtotal_price);
  if (items_subtotal_price == "0") {
    items_subtotal_price = "000";
  }
  freeDeliveryAmount(items_subtotal_price);

  //mini cart info update
  document.querySelector(".mini-cart__heading #total-products").textContent =
    data.item_count;
  document.querySelector(".header__basket-counter").textContent =
    data.item_count;
  let old_price = document.querySelector(".mini-cart__pricelist > span");
  if (old_price && original_total_price) {
    old_price.textContent =
      "$" +
      original_total_price.slice(0, original_total_price.length - 2) +
      "." +
      original_total_price.slice(-2);
  } else if (!old_price && original_total_price != items_subtotal_price) {
    let span = document.createElement("span");
    document.querySelector(".mini-cart__pricelist").prepend(span);
    old_price = document.querySelector(".mini-cart__pricelist > span");
    old_price.textContent =
      "$" +
      original_total_price.slice(0, original_total_price.length - 2) +
      "." +
      original_total_price.slice(-2);
  }
  if (original_total_price == items_subtotal_price && old_price) {
    old_price.remove();
  }
  document.querySelector(".mini-cart__pricelist > p").textContent =
    "$" +
    items_subtotal_price.slice(0, items_subtotal_price.length - 2) +
    "." +
    items_subtotal_price.slice(-2);

  if (document.querySelector(".totals__total-value")) {
    document.querySelector(".totals__total-value").textContent =
      "$" +
      items_subtotal_price.slice(0, items_subtotal_price.length - 2) +
      "." +
      items_subtotal_price.slice(-2);
  }

  //get to free shipping banner
  //cart info update
}
function updateCartItemCount() {
  let totalCount = 0;

  document.querySelectorAll(".mini-cart__order").forEach((item) => {
    let quantity = parseInt(item.querySelector(".quantity-input").value, 10);
    totalCount += quantity;
  });

  document.querySelector("#total-products").textContent = totalCount;
}

function processAddToCartProduct(product, form) {
  
        

      let add_count = 1;
      if (product.classList.contains("add-with-count")) {
        add_count = parseInt(
          document.querySelector(
            '.counter__value[form="' + form.getAttribute("id") + '"]'
          ).value
        );
      }
      console.log(`add_count: `, add_count);
      let key =
        product.getAttribute("data-key") || e.target.getAttribute("data-key");
      console.log(key);

      let productImage = product.getAttribute("data-image");
      let productTitle = product.getAttribute("data-title");
      let productPrice = product.getAttribute("data-price");
      console.log(productImage, productTitle, productPrice);

      let miniCart = document.querySelector(".mini-cart__orders");
      let keysRaw = miniCart.querySelectorAll("[data-key]");
      console.log(keysRaw);

      let keys = Array.from(keysRaw).map((key) => {
        let dataKey = key.getAttribute("data-key");
        return dataKey ? dataKey.split(":")[0] : "";
      });
      console.log(keys);
      let existingItem = Array.from(keysRaw).find((keyy) => {
        return keyy.getAttribute("data-key").split(":")[0] === key;
      });

      console.log(existingItem);

      if (existingItem) {
        console.log(existingItem);
        let quantityInput = existingItem.querySelector(".quantity-input");
        let currentQuantity = parseInt(quantityInput.value, 10);
        quantityInput.value = currentQuantity + add_count;
        changeItemQuantity(key, currentQuantity + add_count);
      } else {
        changeItemQuantity(key, add_count);
        let cartItem = document.createElement("li");
        cartItem.classList.add("mini-cart__order");
        cartItem.setAttribute("data-key", key);
        cartItem.setAttribute("data-price", productPrice);
        cartItem.innerHTML = `
            <div class="card-product">
              <a class="card-product__image">
                <picture>
                  <source type="image/webp" srcset="${productImage}">
                  <img width="100" height="100" src="${productImage}" alt="${productTitle}">
                </picture>
              </a>

              <div class="card-product__info">
                <a class="card-product__title">${productTitle}</a>

                <div class="card-product__pricelist">
                  <span class="card-product__price-current">${productPrice}</span>
                </div>

                <div class="counter" data-counter="trash">
                  <div class="counter__button" data-btn-minus>
                    -
                  </div>
                  <input class="counter__value quantity-input" data-input-value type="text" value="${add_count}">
                  <div class="counter__button" data-btn-plus>
                    +
                  </div>
                </div>
              </div>
            </div>
        `;

        miniCart.prepend(cartItem);
        let up = cartItem.querySelector("[data-btn-plus]");
        let down = cartItem.querySelector("[data-btn-minus]");
        // let deleteItem = cartItem.querySelector(".mini-cart__order-delete");

        up.addEventListener("click", (e) => {
          let input = cartItem.querySelector(".quantity-input");
          let value = parseInt(input.value, 10);
          value = isNaN(value) ? 0 : value;
          value++;
          // input.value = value;
          changeItemTotalPrice(cartItem, value, true);
          changeItemQuantity(key, value);
          changeCartQuantity("+");
        });

        down.addEventListener("click", (e) => {
          let input = cartItem.querySelector(".quantity-input");
          let value = parseInt(input.value, 10);
          if (value > 1) {
            value = isNaN(value) ? 1 : value;
            value--;
            // input.value = value;
            changeItemTotalPrice(cartItem, value, true);
            changeItemQuantity(key, value);
            changeCartQuantity("-");
          } else {
            cartItem.remove();
            changeItemQuantity(key, 0);
          }
        });
      }

      updateCartItemCount();
      showMiniCart();
}


document.addEventListener("DOMContentLoaded", async function () {
  console.log("cart-mini.js DOMContentLoaded");
  let addToMiniCart = document.querySelectorAll("button.add-to-mini-cart");

  addToMiniCart.forEach(async (item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();

      let form = item.closest("form");
      if (form) {
        form.addEventListener("submit", (e) => {
          e.preventDefault();
        });
      }
      
      let product = e.target.closest(".add-to-mini-cart") || e.target;
      console.log(product);
      if(item.classList.contains('expiry')) {
        showConfirm("This item has " + product.getAttribute("data-expiry") + "!")
          .then((confirm) => {
            if(confirm) {
              processAddToCartProduct(product, form);
            }
          });
      } else {
              processAddToCartProduct(product, form);
    } });
  });
});

let loaded = false;

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach((node) => {
        try {
          if (!loaded && document.querySelector(".Avada-Offer__ButtonAddToCart")) {
            document
              .querySelector(".Avada-Offer__ButtonAddToCart")
              .addEventListener("click", (e) => {
                setTimeout(() => {
                  getCartInformation();
                  showMiniCart();
                }, 1500);
              });
            console.log("loaded Avada-Offer__ButtonAddToCart");
            loaded = true;
          }
        } catch (e) {
          console.log(e);
        }
      });
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });
